import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { Router } from '@angular/router'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { RouterUtils } from 'libs/shared/utils/helpers/src/lib/router-utils'
import { GbOnlineStatusService } from 'libs/shared/utils/services/src/lib/gb-online-status/gb-online-status.service'
import { concatMap, delay, finalize, of, take } from 'rxjs'

@UntilDestroy()
@Component({
  selector: 'gb-offline-snack-bar',
  templateUrl: './gb-offline-snack-bar.component.html',
  styleUrls: ['./gb-offline-snack-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class GbOfflineSnackBarComponent implements OnInit {
  RELOAD_INTERVALS = [30000, 60000, 60000]
  isLoading = false

  constructor(private onlineStatusService: GbOnlineStatusService, private router: Router) {}

  ngOnInit(): void {
    of(...this.RELOAD_INTERVALS)
      .pipe(
        untilDestroyed(this),
        concatMap((interval) => of(interval).pipe(delay(interval))),
      )
      .subscribe(() => this.onReload())
  }

  onReload(): void {
    this.isLoading = true
    this.onlineStatusService.isOnline$
      .pipe(
        take(1),
        delay(500),
        finalize(() => (this.isLoading = false)),
      )
      .subscribe((isOnline) => {
        if (isOnline) RouterUtils.reloadCurrentRoute(this.router)
      })
  }
}
